module.exports = __webpack_public_path__ + "static/media/quickto-logo--small.e3edae0d.svg";